import React, { useEffect, useState } from 'react'
import $ from 'jquery'
import { useNavigate } from 'react-router-dom';

export default function Task_management() {
  const active_pro_name = localStorage.getItem('selected_project_name');
  const com_id = localStorage.getItem('mem_company_id');
  const assignById = localStorage.getItem('member_id');
  const assignByName = localStorage.getItem('membername');
  const [linkedProjectID, setLinkedProjectId] = useState('')
  var selectedteamMemCount = 0;
  let trackerWindow = null;

  const [listProjectTaskArray, setListProjectTaskArrayy] = useState([]);
  const [listTaskMembersArray, setListTaskMembersArray] = useState([]);
  const [listSelectedMember, setListSelectedMember] = useState([]);

  const navigate = useNavigate();
  useEffect(() => {
    const active_pro_id = localStorage.getItem('selected_project_id');
    getMemListFortsk();
    var obj = {
      pro_id: active_pro_id
    }

    $.ajax({
      type: 'POST',
      url: 'getAllProjectTasks.php',
      data: obj,
      cache: false,
      success: function (result) {
        var res = result;
        if (res !== 'fail' && res !== '') {
          var arr = res;
          var len = arr.length ? arr.length : '0';
          if (len < 1) {
            $('#memnum').text('0');
            $('.notice_text').css('display', 'block');
            $('#norecord').css('display', 'block');
          } else {
            $('#memnum').text(arr.length);
            setListProjectTaskArrayy(arr)
            setTimeout(checksts, 3000);
          }


        } else {
          showAlert('Cannot found any task for this project.');
          $('#norecord').css('display', 'block');
        }
      },
    });
  }, [])

  function checksts() {
    var len = listProjectTaskArray.length;
    if (len < 1) {
      $('#norecord').css('display', 'block');
    } else {

    }
  }

  function getTasksDetails(pr_key, pro_id) {
    localStorage.setItem('redirectto', 'adminmaintask')
    localStorage.setItem('taskid', pr_key);
    localStorage.setItem('taskproid', pro_id);
    navigate('/task_details');
  }

  function removeTask(pr_key) {
    var obj = {
      primary_key: pr_key
    }
    $.ajax({
      type: 'POST',
      url: 'removeProjectTask.php',
      data: obj,
      cache: false,
      success: function (result) {
        if (result != 'fail') {
          showAlert('Removed successfully');
          setTimeout(redirectpage, 1500);
        } else {
          showAlert('Cannot remove task.');
        }
      },
    });
  }

  function openAddTaskPop() {

    $('#addTsx').css('display', 'block');
  }

  function clsoetsxPop() {
    $('.loader_inner').css('display', 'none')
    $('#addTsx').css('display', 'none');
  }

  function getMemListFortsk() {
    const active_pro_id = localStorage.getItem('selected_project_id');
    var obj = {
      pro_id: active_pro_id
    }
    $.ajax({
      type: 'POST',
      url: 'getAllProjectMember.php',
      data: obj,
      cache: false,
      success: function (result) {
        var res = result;

        if (res !== 'fail' && res !== '') {
          try {
            var tskarr = res;

            // ensure it's an array
            if (Array.isArray(tskarr)) {
              var len = tskarr.length;
              if (len < 1) {
                $('#promem').css('display', 'block');
                $('#no_member_notoce').text('You have not create team for this project. Go to the member area and create a team.')
              } else {
                setListTaskMembersArray(tskarr);
              }
            } else {
              // if memarr is null or not an array
              setListTaskMembersArray([]);
            }

          } catch (e) {
            console.error("Invalid JSON from backend:", e);
            $('#memnum').text('0');
            setListTaskMembersArray([]);
          }
        } else {
          showAlert('Cannot found any member for this project.');
          setListTaskMembersArray([]);
        }
      },
    });
  }
  function showAlert(msg) {
    $('#alertpop').css('display', 'block');
    $('#alert_text').text(msg);
  }

  function closeAlert() {
    $('#alertpop').css('display', 'none');
    $('#alert_text').text('');
  }

  function selectTheMem(ind) {
    var trgid = 'mem' + ind;
    $('#' + trgid + ' .member_list_button').addClass('activeBtn')
    var memberid = listTaskMembersArray[ind].memberid;
    var com_id = listTaskMembersArray[ind].mem_com_id;
    var pro_id = listTaskMembersArray[ind].proid;
    var proname = listTaskMembersArray[ind].proname;
    var member_name = listTaskMembersArray[ind].membername;
    var status_member = listTaskMembersArray[ind].status_member;

    var obj = {
      id: ind,
      memberid: memberid,
      com_id: com_id,
      pro_id: pro_id,
      proname: proname,
      member_name: member_name,
      status_member: status_member
    }
    setListSelectedMember(prevArray => [...prevArray, obj]);
  }

  function removeMem(ind) {
    var trgid = 'mem' + ind;
    $('#' + trgid + ' .member_list_button').removeClass('activeBtn')
    setListSelectedMember(prevArray =>
      prevArray.filter(member => member.id !== ind)
    );
  }

  function saveTask() {
    $('.loader_inner').css('display', 'block')
    var timehr = $('#tsk_time_hour').val();
    var timemn = $('#tsk_time_min').val();
    var fulltime = timehr + ':' + timemn;
    var project_id = localStorage.getItem('selected_project_id');
    var project_name = localStorage.getItem('selected_project_name');
    var tsx_name = $('#tsx_name').val() || 'No Name Provided';
    var tsx_desc = $('#tsx_desc').val();
    var files = $('#comm_file')[0].files; // array of selected files
    var tsk_assign_by = localStorage.getItem('membername');
    var tsk_assign_id = localStorage.getItem('member_id');
    var com_id = localStorage.getItem('mem_company_id');

    var formData = new FormData();
    formData.append('proid', project_id);
    formData.append('proname', project_name);
    formData.append('tsx_name', tsx_name);
    formData.append('tsx_desc', tsx_desc);
    formData.append('txn_id', generateId());
    formData.append('tsk_status', 'pending');
    formData.append('tsk_assign_by', tsk_assign_by);
    formData.append('tsk_assign_id', tsk_assign_id);
    formData.append('assignDate', getCurrentDateMMDDYYYY());
    formData.append('assign_time', fulltime);
    formData.append('Company_id', com_id);
    for (let i = 0; i < files.length; i++) {
      formData.append('attachments[]', files[i]); // [] makes it an array in PHP
    }


    $.ajax({
      type: 'POST',
      url: 'save_the_task.php',
      data: formData,
      cache: false,
      contentType: false,   // ❌ prevent jQuery from setting Content-Type
      processData: false,   // ❌ prevent jQuery from processing data
      success: function (result) {
        if (result != 'fail') {
          saveSelectedNames(result, tsx_name, tsx_desc);
        } else {
          clsoetsxPop();
          showAlert("Cannot save task. Try later sometime");
        }
      },
      error: function (xhr, status, error) {
        console.error("AJAX Error:", status, error);
      }
    });

  }

  function getCurrentDateMMDDYYYY() {
    const today = new Date();
    const mm = String(today.getMonth() + 1).padStart(2, '0'); // Months are zero-based
    const dd = String(today.getDate()).padStart(2, '0');
    const yyyy = today.getFullYear();

    return `${mm}-${dd}-${yyyy}`;
  }


  function saveSelectedNames(res, tsx_name, tsx_desc) {
    var tsk_assign_id = localStorage.getItem('member_id');
    var tskmember_arr = listSelectedMember;
    var tskcm = $('#tsx_name').val();
    var tskid = res.replace(/\D/g, ''); // Keeps only digits;
    let shortText = tsx_desc.slice(0, 120);
    var leng = tskmember_arr.length;
    if (selectedteamMemCount < leng) {
      var obj = {
        id: tskmember_arr[selectedteamMemCount].ind,
        memberid: tskmember_arr[selectedteamMemCount].memberid,
        com_id: tskmember_arr[selectedteamMemCount].com_id,
        pro_id: tskmember_arr[selectedteamMemCount].pro_id,
        proname: tskmember_arr[selectedteamMemCount].proname,
        member_name: tskmember_arr[selectedteamMemCount].member_name,
        status_member: tskmember_arr[selectedteamMemCount].status_member,
        tsk_id: tskid,
        tsk_name: tsx_name,
        tsx_desc: tsx_desc,
        assignById: tsk_assign_id
      }
      $.ajax({
        url: 'save_tsk_member.php',
        type: 'POST',
        data: obj,
        success: function (response) {
          if (response != 'fail') {
            repeat_the_same(res, tsx_name, tsx_desc);
          } else {
            clsoetsxPop();
            showAlert("Cannot save task as one of your member history cannot save")
          }

        }
      });
    } else {
      sendNotifications('task', tskid, tsx_name)

    }
  }
  function sendNotifications(type, task_id, purpose_name) {
    var company_id = localStorage.getItem('mem_company_id');
    var uniqueid = crypto.randomUUID();
    var creator_id = localStorage.getItem('member_id');
    var obj = {
      company_id: company_id,
      ref_id: task_id,
      type: 'task',
      creator_name: localStorage.getItem('membername'),
      purpose: 'New task',
      purpose_name: purpose_name,
      project_id: linkedProjectID,
      task_id: task_id,
      goal_id: task_id,
      project_name: '',
      task_name: purpose_name,
      unid: uniqueid,
      creator_id: creator_id
    }
    $.ajax({
      type: 'POST',
      url: 'add_notifications.php',
      data: obj,
      cache: false,
      success: function (result) {
        clsoetsxPop();
        showAlert("Task saved successfully")
        setTimeout(redirectpage, 1500);


      },
    });
  }

  function redirectpage() {
    localStorage.setItem('initialpage', 'task');
    navigate('/redirect_task');
  }

  function repeat_the_same(res, tsx_name, tsx_desc) {
    selectedteamMemCount++;
    saveSelectedNames(res, tsx_name, tsx_desc);
  }


  function generateId() {
    return 'id-' + Date.now().toString(36) + '-' + Math.random().toString(36).substr(2, 9);
  }

  function getCompleteTasksDetails(pr_key, pro_id) {
    localStorage.setItem('taskid', pr_key);
    localStorage.setItem('taskproid', pro_id);
    navigate('/completetask_details');
  }

  function startwork(tsk_id, pro_id, tskname, tskdetails) {
    var userid = localStorage.getItem('member_id');
    var pr_key = tsk_id;
    var tsk_name = tskname;
    var mem_name = localStorage.getItem('membername');
    var company_id = localStorage.getItem('mem_company_id');
    var pid = pro_id;
    var active_pro_name = localStorage.getItem('selected_project_name');;
    var comname = localStorage.getItem('mem_company_name');
    var task_details = tskdetails;
    var comlohgo = localStorage.getItem('companylogo');
    const params = new URLSearchParams({
      task_id: pr_key,
      project_id: pid,
      member_id: userid,
      member_name: mem_name,
      mem_com_id: company_id,
      task_name: tsk_name,
      active_pro_name: active_pro_name,
      comname: comname,
      task_details: task_details,
      comlohgo: comlohgo
    });

    const url = `time_tracker.php?${params.toString()}`;
    if (trackerWindow && !trackerWindow.closed) {
      trackerWindow.focus();
      return;
    }
    trackerWindow = window.open(
      url,
      'timeTrackerWindow',
      'width=420,height=420,resizable=no,alwaysRaised=yes,scrollbars=no,toolbar=no,menubar=no,location=no'
    );
  }


  return (
    <div>
      <div className='topbar_menu'>
        <button className='member_button' onClick={openAddTaskPop}>Add Task</button>
        <p>Project name : {active_pro_name}</p>
        <p>Current Number Of Pending Tasks : <span id="memnum"></span></p>
      </div>

      <div className='member_row'>

        <div className='member_details'>
          <section className='vl_dsh_bodypart_section pos_rel'>

            <div className='vl_listing_area'>
              <div className='vl_listing_row listheading_row'>
                <div className='vl_listing_cell width15'>
                  <h4 className='prj_name'>Task Name</h4>
                </div>
                <div className='vl_listing_cell width50'>
                  <p>Task details</p>

                </div>

                <div className='vl_listing_cell width25'>
                  <p>Assign By</p>
                </div>

                <div className='vl_listing_cell width10'>
                  <p>Action</p>
                </div>
              </div>
              <div className='vl_listing_row nodisplay' id="norecord">
                <h1 className='notice_text'> No Record Found</h1>
              </div>
              {Array.isArray(listProjectTaskArray) &&
                listProjectTaskArray.map((item, index) => {
                  const userid = localStorage.getItem('member_id');
                  const isComplete = item.tsk_status === "complete";
                  const creatorid = item.assignById;
                  const adminmember = localStorage.getItem('user_position');
                  const candelete = !isComplete && Number(creatorid) === Number(userid) || adminmember !== 'Member';

                  return (
                    <div
                      key={index}
                      className="vl_listing_row"
                      style={{
                        backgroundColor: isComplete ? "#d4edda" : "transparent", // light green for complete
                      }}
                    >
                      <div className="vl_listing_cell width15">
                        <h4 className="prj_name">{item.taskname}</h4>
                        <input id="proj_id" type="hidden" value={item.proj_id} />
                        <input id="tsk_com_id" type="hidden" value={item.tasjk_com_id} />
                        <input id="tsk_primary_key" type="hidden" value={item.primary_key} />

                        <span>Status: {item.tsk_status}</span>
                        <span>Date: {item.assigneDate}</span>
                      </div>

                      <div className="vl_listing_cell width50">
                        <p>{item.task_details}</p>
                        <div className="inforow">
                          <span>Time: {item.assign_time} hrs.</span>
                          <span>Worked: {item.wordkedhours} hrs.</span>
                          <span>Status: {item.tsk_status}</span>

                          <span>

                            {!isComplete && (
                              <button
                                className="startbutton"
                                onClick={() => startwork(item.primary_key, item.proj_id, item.taskname, item.task_details)}
                              >
                                Start Work
                              </button>
                            )}
                          </span>
                        </div>
                      </div>

                      <div className="vl_listing_cell width25">
                        <p>{item.assigneBy}</p>
                      </div>

                      <div className="vl_listing_cell width10">
                        {/* Change function based on completion */}
                        <button
                          onClick={() => {
                            isComplete
                              ? getCompleteTasksDetails(item.primary_key, item.proj_id)
                              : getTasksDetails(item.primary_key, item.proj_id);
                          }}
                        >
                          Details
                        </button>

                        {/* Hide delete button if task is complete */}
                        {candelete && (
                          <button
                            className="rightgap backtranparent"
                            onClick={() => removeTask(item.primary_key)}
                          >
                            <i className="ri-delete-bin-3-fill"></i>
                          </button>
                        )}
                      </div>
                    </div>
                  );
                })}

            </div>
          </section>
        </div>
      </div>
      <div className='vl_dsh_popup' id="addTsx">
        <div className='formareacase'>
          <button className='popcls' onClick={clsoetsxPop}>X</button>
          <div className='form_block'>
            <h3>{active_pro_name}</h3>
            <div className='form_row'>
              <label>Heading</label>
              <input type="text" id="tsx_name" placeholer="Enter Name" />
            </div>
            <div className='form_row'>
              <label>Description</label>
              <textarea id="tsx_desc"></textarea>
            </div>
            <div className='form_row'>
              <label>Upload Files</label>
              <input type="file" id="comm_file" multiple />
            </div>
            <div className='form_row'>
              <label>Time Line</label>
              <div className='timeblock'>
                <p>Hour</p>
                <input type="number" id="tsk_time_hour" placeholer="Hours" />
              </div>
              <div className='timeblock'>
                <p>Minutes</p>
                <input type="number" id="tsk_time_min" placeholer="Hours" />
              </div>

            </div>
            <div className='form_row'>
              <p className='captiontext'>Assign to : -</p>
              <div className='mem_list_area' id="promem">
                <h3 id="no_member_notoce"></h3>
                {listTaskMembersArray.map((item, index) => (

                  <div className='vl_listing_button_cell' id={`mem${index}`}>
                    <button className='member_list_button' onClick={() => { selectTheMem(index) }}>{item.membername}</button>
                    <i className='ri-delete-bin-3-fill removeico' onClick={() => { removeMem(index) }}></i>
                  </div>
                ))}
              </div>

            </div>
            <div className='btn_holder'>
              <button className='save_btn' onClick={saveTask}>Save</button>
            </div>
          </div>
        </div>
        <div className='loader_inner'>
          <p>Saving your date....please wait</p>
        </div>
      </div>
      <div className='vl_dsh_popup' id="alertpop">
        <div className='alertbox'>
          <div className='alertheader'><h3><i className='ri-alert-line'></i>Alert</h3></div>
          <div className='contentarea'>
            <p id="alert_text"></p>
          </div>
          <div className='alert_btns'>
            <button onClick={closeAlert}>Okay</button>
          </div>
        </div>
      </div>
    </div>
  )
}
